import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { MiscApi, RequestStrategyEnum, type WithSignal } from '@shared/api';

const getCurrenciesEffect = createEffect(({ signal }: WithSignal = {}) => MiscApi.getCurrencies(signal));
const clearEvent = createEvent();

const $dataStore = createStore<string[]>([])
  .on(getCurrenciesEffect.done, (_, data) => data.result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getCurrenciesEffect.pending, (_, data) => data)
  .on(getCurrenciesEffect.fail, () => false)
  .on(getCurrenciesEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getCurrenciesEffect, () => null)
  // .on(getCurrenciesEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getCurrenciesEffect.fail, () => 'Something went wrong while fetching Currencies. Please try again.')
  .on(getCurrenciesEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $currenciesStore = {
  events: {
    getCurrencies: ApiUtils.wrapperApi(getCurrenciesEffect, RequestStrategyEnum.Debounce).trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
